import { Button } from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { BugReportDialog } from "../components/dialog/BugReportDialog";
import { DataGrid } from "@material-ui/data-grid";
import { CustomLoading, CustomNoBugsOverlay } from "../components/utils/tableComponents";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import { formatAnonymous } from "../api/utils/strings";
import { CustomBugFilters } from "../components/search/CustomFilters";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import PublicIcon from "@mui/icons-material/Public";
import PublicOffIcon from "@mui/icons-material/PublicOff";
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import Tooltip from '@mui/material/Tooltip';
import { useTour } from "@reactour/tour";
import { stepsBugReport } from "../components/tour/TourConfig";
//import "../styles/devices/mob_SignsTable.css";
import clsx from "clsx";
import "../styles/devices/mob_BugReport.css";
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";
import { useTranslation } from "react-i18next";


export function BugReport() {
  const { t } = useTranslation("global")

  /* Dialog */
  const [openDialog, setOpenDialog] = useState(false);
  const [closeDialog, setCloseDialog] = useState(false);
  const { token_id, currentUser } = useDataProvider();
  const { comm_createReportBug, comm_getReportBug } = useCommProvider();
  const [snack, setSnack] = useState({ open: false, text: "" });
  const [admin_lookup, setAdmin_lookup] = useState(false);
  //   const [input_Labels, setLabels] = useState([]);
  //   const [input_Title, onChangeTextTitle] = useState("");
  //   const [input_Body, onChangeTextBody] = useState("");
  
  /* Tour */
  const { setIsOpen, setSteps, setCurrentStep, currentStep, isOpen } = useTour();
  const customTourSteps = useRef([]);

  function handleOpenTour(steps, initStep) {
    setSteps(steps);
    setCurrentStep(initStep);
    setIsOpen(true);
  }

  /* Sorting and Filtering */
  const [filterMenuActive, setFilterMenuActive] = useState(false);
  const [sortModel, setSortModel] = useState([{ field: "updated_at", sort: "desc" }]);
  const [filterState, setFilterState] = useState([
    false, // orderAsc
    true, // orderDesc
    false, // orderByTitle
    false, // orderByState
    true, // orderByModDate
    true,  // showUID
    true,  // showStateNew
    true,  // showStateOpen
    true,  // showStatePending
    false, // showStateResolved
    false, // showStateClosed
    true, // tagBug
    true, // tagDoc
    true, // tagLSE
    true, // tagImp
    true, // tagPre
    true, // tagQue
    true, // tagWeb
  ]);

  const [rows, setRows] = useState([]);
  const [urlReport, setUrlReport] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  async function sendReportBug(data) {
    try{
      const response = await comm_createReportBug(token_id, currentUser, data);
      setSnack({ ...snack, open: true, text: "Reporte generado: ", type: "info", web: { label: "Enlace", url: response['url_created'] } });
    }catch(e){
      console.error(e)
      setSnack({ ...snack, open: true, text: e, type: "error" });
    }
  }

  const handlePostNewReport = () => {
    // MOB - Change 'New Report' button behaviour when tour is open and we are on second step
    if (isOpen && currentStep === 1) {
      setCurrentStep(2);
    } else{
      setOpenDialog(true);
    }
  };

  /* BUG REPORT TABLE */
  const [columns, setColumns] = useState([
    { field: "title", headerName: t("sTable.title"), sortable: false, flex: 2 },
    { field: "state", headerName: t("sTable.state"), sortable: false, flex: 1, renderCell: (params) => gridGetState(params) },
    { field: "labels", headerName: t("sTable.tags"), sortable: false, flex: 1, renderCell: (params) => gridGetTags(params) },
    { field: "updated_at", headerName: t("sTable.updated"), type: "date", sortable: false, flex: 1 },
    { field: "user_id", headerName: t("sTable.user"), sortable: false, flex: 1, renderCell: (params) => gridGetUser(params) },
    //{ field: "html_url", headerName: "Enlace", sortable: false, flex: 0.7, renderCell: (params) => gridGetLink(params) }, MOB - Temp disabled
  ]);
  

  function gridGetUser(params) {
    const issueUser = currentUser.uid === params.row.user_id ? t("sTable.incident_mine") : t("sTable.incident_other_user");
    return <span>{issueUser}</span>
  }

  function gridGetState(params) {
    return <div className={`sig_BugReport_State sig_BugReport_State${params.row.state}`}>{params.row.state}</div>;
  }

  // function gridGetLink(params) {
  //   return (
  //     <a href={`${params.row.html_url}`} target="_blank" rel="noopener noreferrer">
  //       <OpenInNewIcon className="sig_BugReport_LinkIcon" />
  //     </a>
  //   );
  // }

  function gridGetTags(params) {
    const tags = [];
    params.row.labels.map((i, index) => {
      tags.push(
        <div className={`sig_BugReport_Tag sig_BugReport_Tag_${i.normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`} key={index}>
          {i}
        </div>
      );
    });
    return <div className="sig_BugReport_TagsContainer">{tags}</div>;
  }

  /* Pagination */
  function handlePageSizeChange(params) {
    setPageSize(params.pageSize);
  }

  useEffect(() => {
    // console.log("urlreport", urlReport)
    if (urlReport != null) {
      let bugList = urlReport.map((j) => {
        // Object destructuring, selecting only the needed properties.
        // MOB - locked, created_at and closed_at where ommited, check if that is Ok.
        let aux = (({ id, user_id, title, html_url }) => ({ id, user_id, title, html_url }))(j);

        // Modified date formatting
        aux.updated_at = j.updated_at.slice(0, -1).replace("T", " ");

        // Keep conditional if for the text localization if there are onle two possible states. Otherwise, a simple switch might work too.
        if (j.state === "open") {
          aux.state = "Abierto";
        } else {
          aux.state = "Cerrado"; // j.state === "closed"
        }

        // Label and further state formatting - Only the label's names are kept
        aux.labels = [];
        j.labels.map((k, kIndex) => {
          if (k.name === "incidencia_nueva") {
            aux.state = "Nuevo";
          } else if (k.name === "incidencia_pendiente") {
            aux.state = "Pendiente"; // "Esperando respuesta", "Pendiente de respuesta", "Pendiente de revisión", "Respuesta necesaria", "Nuevo mensaje", ...
          } else if (k.name === "incidencia_resuelta") {
            aux.state = "Resuelto";
          } else {
            aux.labels[kIndex] = k.name.toUpperCase();
          }         
        });
        return aux;
      });
      setRows(bugList);
    }
  }, [urlReport]);

  useEffect(() => {
    async function handleGetReportByUser() {
      const uid = currentUser.isAnonymous ? formatAnonymous(currentUser.uid) : currentUser.uid;
      try{
        setUrlReport(await comm_getReportBug(token_id, currentUser))
      }catch(e){
        console.error(e)
        setSnack({ ...snack, open: true, text: e, type: "error" });
      }
    }
    handleGetReportByUser();

    // MOB - Customize tour steps to enable the use of component functions
    customTourSteps.current = [...stepsBugReport];
    customTourSteps.current[2] = {
      selector: '[data-tour="tourBug_3"]',
      content: () => (
          <div className="sig_Tour_Container">
              <h4 className="sig_Tour_Title">
                { t("sBugReport.incident_new_report") }
              </h4>
              <p className="sig_Tour_Content">
                { t("sBugReport.incident_field_neccesary") }
              </p>
          </div>
      ),
      highlightedSelectors: ['[data-tour="tourBug_3"]'],
      mutationObservables: ['.sig_Drawer_SettingsModal_Root'],
      action: () => (handlePostNewReport()),
      actionAfter: () => (setCloseDialog(close => !close)),
    };
  }, []);

  async function handleGetReportByUserAdmin() {
    try{
      if (admin_lookup === true) {
        setAdmin_lookup(false);
        setUrlReport(await comm_getReportBug(token_id, currentUser))
      } else {
        setAdmin_lookup((admin_lookup) => !admin_lookup);
        setUrlReport(await comm_getReportBug(token_id, currentUser, "global"))
      }
    }catch(e){
      console.error(e)
      setSnack({ ...snack, open: true, text: e, type: "error" });
    }
  }

  /* Click cell */
  function handleRowClick(params, event) {
    window.open(params.row.html_url, '_blank', 'noopener noreferrer'); // MOB - Check
  }

  /* Filter menu */
  const handleFilterOptions = (event, filterId, newFilterState) => {
    let fieldName = "";

    if (newFilterState[2] === true) {
      fieldName = "title";
    } else if (newFilterState[3] === true) {
      fieldName = "state";
    } else if (newFilterState[4] === true) {
      fieldName = "updated_at";
    }

    if (filterId >= 0) {
      if (filterId <= 1) {
        if (sortModel[0]["sort"] === "asc") {
          setSortModel([{ field: fieldName, sort: "desc" }]);
        } else {
          setSortModel([{ field: fieldName, sort: "asc" }]);
        }
      } else if (filterId <= 4) {
        setSortModel([{ field: fieldName, sort: sortModel[0]["sort"] }]);
      } else if (filterId === 5) {
        let auxCol = [];
        if (newFilterState[5] === false) {
          auxCol = columns.filter((c, i) => {
            return c.field !== "user_id";          
          });          
        } else {
          auxCol = [...columns];
          auxCol.push({ field: "user_id", headerName: "Usuario", sortable: false, flex: 1 })
        }
        setColumns(auxCol);
      }
    }

    setFilterState(newFilterState);
  };

  function handleFilterMenu() {
    setFilterMenuActive((state) => !state);
  }

  function handleNoRowsOverlay() {
    return CustomNoBugsOverlay(admin_lookup);
  }

  return (
    <HomeWrapper>
      <PageTitle title= {t("sBugReport.title")} />
      <div className="sig_BugReport_Root">
        <div className={`sig_ST_CustomFilters_MenuBkg sig_Home_ChangeOnDarkMode ${filterMenuActive ? "" : "sig_ST_CustomFilters_MenuBkg_Hidden"}`} onClick={handleFilterMenu}></div>
        <div className="sig_BugReport_ButtonsContainer">
          <Button data-tour="tourBug_2" className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={handlePostNewReport}>
            { t("sBugReport.generate_new_report") }
          </Button>
          <Tooltip title={t("sTooltip.filters_options")} placement='bottom' arrow>
            <div data-tour="tourBug_5" className="sig_Main_IconButton" onClick={handleFilterMenu}>
              {filterMenuActive ? <FilterAltIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" /> : <FilterAltOutlinedIcon className="sig_ST_CustomFilters_MenuIcon sig_Home_ChangeOnDarkMode" />}
            </div>
          </Tooltip>
          <Tooltip title={t("sTooltip.show_help")} placement="bottom" arrow>
            <div data-tour="tourBug_1" className="sig_Main_IconButton" onClick={() => handleOpenTour(customTourSteps.current, 0)}>
              <LiveHelpIcon className="sig_Home_ChangeOnDarkMode"/>
            </div>
          </Tooltip>
          <Tooltip title={t("sTooltip.global_reports")} placement='bottom' arrow>
            <Button data-tour="tourBug_4" className={`${admin_lookup ? "sig_SignDialog_Button_AdminReportBug_clicked" : "sig_SignDialog_Button_AdminReportBug"} sig_Home_ChangeOnDarkMode`} onClick={handleGetReportByUserAdmin}>
              {admin_lookup ? <PublicIcon className="sig_Home_ChangeOnDarkMode" fontSize="small" /> : <PublicOffIcon className="sig_Home_ChangeOnDarkMode" fontSize="small" />}
            </Button>
          </Tooltip>
        </div>
        <BugReportDialog openDialog={openDialog} setOpenDialog={setOpenDialog} sendReportBug={sendReportBug} closeDialog={closeDialog} />
        <HelpSnackbar snack={snack} setSnack={setSnack} />
        {urlReport !== "null" ? (
          <>
            <div className="sig_BugReport_ST_Container">
              <DataGrid
                className={clsx("sig_BugReport_ST", {
                  sig_BugReport_HideTopRow: ((urlReport == null) || (urlReport.length === 0)),
                  sig_BugReport_ShowUID: filterState[5],
                  sig_BugReport_ShowBUG: filterState[11],
                  sig_BugReport_ShowDOCUMENTACION: filterState[12],
                  sig_BugReport_ShowLSE: filterState[13],
                  sig_BugReport_ShowMEJORA: filterState[14],
                  sig_BugReport_ShowPREDICCION: filterState[15],
                  sig_BugReport_ShowPREGUNTA: filterState[16],
                  sig_BugReport_ShowWEB: filterState[17],
                })}
                getRowClassName={(params) => {
                  let cName = "";
                  const rTags = params.getValue(params.id, "labels");
                  for (let i = 0; i < rTags.length; i++) {
                    cName += `sig_BugReport_Show${rTags[i].normalize("NFD").replace(/[\u0300-\u036f]/g, "")} `;
                    // MOB - This introduces an extra space at the end of the inserted class names.
                    // It shouldn't cause any problems, but could be fixed if needed by using the
                    // following line at the end of the string addition: ${(i < (rTags.length-1)) ? ' ' : ''}
                  }
                  const rState = params.getValue(params.id, 'state');
                  if ((!filterState[6] && rState === "Nuevo") || 
                      (!filterState[7] && rState === "Abierto") ||
                      (!filterState[8] && rState === "Pendiente") ||
                      (!filterState[9] && rState === "Resuelto") ||
                      (!filterState[10] && rState === "Cerrado")) { 
                        cName += ' sig_BugReport_StatePriorityHideRow' 
                      }
                  return cName;
                }}
                autoHeight
                pageSize={pageSize}
                onPageSizeChange={handlePageSizeChange}
                rowsPerPageOptions={[10, 25, 50, 100]}
                pagination
                disableSelectionOnClick
                disableColumnMenu
                columns={columns}
                rows={rows}
                sortModel={sortModel}
                onRowClick={handleRowClick}
                components={{
                  LoadingOverlay: CustomLoading,
                  NoRowsOverlay: handleNoRowsOverlay,
                }}
              />
            </div>
          </>
        ) : (
          <></>
        )}
        <CustomBugFilters active={filterMenuActive} handleFilterOptions={handleFilterOptions} handleFilterMenu={handleFilterMenu} />
      </div>
    </HomeWrapper>
  );
}
